export const MERCHANT = 2;
export const RETAIL = 3;
export const PRIVATE_SALE = 4;
export const PRIVATE_LISTING_SELLER = 5;
